import { createContext } from 'react'

export type ToastKind = 'success' | 'error' | 'info'

export interface ToastInput {
  id?: string
  kind?: ToastKind
  title: string
  description?: string
  actionLabel?: string
  onAction?: () => void
}

export interface ToastContextValue {
  showToast: (toast: ToastInput) => void
  dismissToast: (id: string) => void
}

export const ToastContext = createContext<ToastContextValue | null>(null)
